import { safetyTips, glossaryItems } from "@/mocks/homeData";

const toneMap: Record<string, { icon: string; ring: string }> = {
  primary: { icon: "bg-primary-100 text-primary-700", ring: "border-primary-200" },
  accent: { icon: "bg-accent-100 text-accent-800", ring: "border-accent-200" },
  secondary: { icon: "bg-secondary-100 text-secondary-800", ring: "border-secondary-200" },
};

export default function Safety() {
  return (
    <section id="safety" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700 uppercase tracking-wider">
            <i className="ri-shield-check-line"></i>
            Safety First
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            比「打开」更重要的：访问时的安全底线
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            因为打不开而着急的时候，最容易做出「先下载试试」「先填个信息」这类高风险动作。
            下面几条底线，值得在任何情况下都守住。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {safetyTips.map((t) => {
            const tone = toneMap[t.tone];
            return (
              <div
                key={t.title}
                className={`rounded-lg bg-background-100 border ${tone.ring} p-5 md:p-6 flex gap-4`}
              >
                <span className={`w-11 h-11 rounded-md flex items-center justify-center text-xl shrink-0 ${tone.icon}`}>
                  <i className={t.icon}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{t.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-lg bg-background-100 border border-background-200/80 p-5 md:p-7">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
              <i className="ri-book-2-line"></i>
            </span>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">术语速查</h3>
          </div>
          <dl className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {glossaryItems.map((g) => (
              <div key={g.term} className="flex gap-3">
                <dt className="shrink-0 w-24 font-heading text-sm font-semibold text-primary-700">{g.term}</dt>
                <dd className="text-sm text-foreground-600 leading-relaxed">{g.desc}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}